
/**
 * Cancels the browser defaults for the keys a dropdown owns, so they do not also scroll the page
 * or submit the surrounding form.
 *
 * Filtering by key has to happen here: Blazor's @onkeydown:preventDefault is unconditional, and on
 * a text field that would swallow the typing itself.
 *
 * @param {HTMLElement} element - The dropdown container to listen on
 */
function preventDropdownKeyDefaults(element) {
    if (!element) return;

    element.addEventListener('keydown', (event) => {
        const isArrow = event.key === 'ArrowDown' || event.key === 'ArrowUp';

        // Enter commits the highlighted option; inside a dropdown it never means "submit"
        const isEnter = event.key === 'Enter';

        // space opens a shut control, but inside a text field it is a character being typed
        const isSpaceOutsideTextField = event.key === ' ' && !event.target.closest('input, textarea');

        if (isArrow || isEnter || isSpaceOutsideTextField) {
            event.preventDefault();
        }
    });
}

/**
 * Keeps the arrow-key highlight in view as it moves down a scrolling list.
 * @param {string} listId - Id of the scrollable list element
 */
function scrollActiveOptionIntoView(listId) {
    const listElement = document.getElementById(listId);
    if (!listElement) return;

    const activeItem = listElement.querySelector('.is-active');
    if (activeItem) {
        const offset = -30;
        listElement.scrollTop = activeItem.offsetTop + offset - listElement.offsetTop;
    }
}

/**
 * Checks if focus is moving to an element within the dropdown container.
 * @param {HTMLElement} dropdownElement - The dropdown container element
 * @returns {boolean} - True if focus is staying within the dropdown, false otherwise
 */
function isFocusWithinDropdown(dropdownElement) {
    if (!dropdownElement) return false;

    const activeElement = document.activeElement;
    return dropdownElement.contains(activeElement);
}

globalThis.dropdown = {
    preventDropdownKeyDefaults,
    scrollActiveOptionIntoView,
    isFocusWithinDropdown
}
